// ============================================
// INFRASTRUCTURE - Caja Repository
// ============================================

import { axiosClient } from './axios-client';
import type { AperturaCajaDto, AperturaCajaResponse, CierreCajaDto, VendedorCaja, CuadraturaCajaResponse, FiltrosCuadraturaCaja, CuadraturaCaja, CajaStatusResponse } from '../../domain/dtos';

export const cajaRepository = {
  /**
   * Apertura de caja
   * POST /cuadratura-cajas
   */
  async abrirCaja(dto: AperturaCajaDto): Promise<AperturaCajaResponse> {
    const { data } = await axiosClient.post<AperturaCajaResponse>(
      '/cuadratura-cajas',
      dto
    );
    return data;
  },

  /**
   * Cierre de caja
   * PUT /cuadratura-cajas/{id}/cerrar
   */
  async cerrarCaja(dto: CierreCajaDto): Promise<void> {
    await axiosClient.put(
      `/cuadratura-cajas/${dto.cuadraturaCajaId}/cerrar`,
      dto
    );
  },

  /**
   * Obtener cuadraturas de caja
   * GET /cuadratura-cajas
   */
  async obtenerCuadraturas(): Promise<any[]> {
    const { data } = await axiosClient.get('/cuadratura-cajas');
    return data;
  },

  /**
   * Obtener vendedores para caja
   * GET /usuarios/caja
   */
  async obtenerVendedoresCaja(): Promise<VendedorCaja[]> {
    const { data } = await axiosClient.get<VendedorCaja[]>('/usuarios/caja');
    return data;
  },

  /**
   * Obtener cuadraturas de caja abiertas
   * GET /cuadratura-cajas/open
   */
  async obtenerCuadraturasAbiertas(): Promise<CuadraturaCajaResponse> {
    const { data } = await axiosClient.get<CuadraturaCajaResponse>('/cuadratura-cajas/open');
    return data;
  },

  /**
   * Obtener cuadraturas de caja con filtros
   * GET /cuadratura-cajas/filters?fechaInicio=DD-MM-YYYY&fechaFin=DD-MM-YYYY
   */
  async obtenerCuadraturasConFiltros(filtros: FiltrosCuadraturaCaja): Promise<CuadraturaCajaResponse> {
    const page = filtros.page ?? 0;
    const { data } = await axiosClient.get<CuadraturaCajaResponse>(
      `/cuadratura-cajas/filters?fechaInicio=${filtros.fechaInicio}&fechaFin=${filtros.fechaFin}&page=${page}`
    );
    return data;
  },

  /**
   * Cerrar caja
   * POST /cuadratura-cajas/{cajaId}/close
   */
  async cerrarCajaById(cajaId: number): Promise<CuadraturaCaja> {
    const { data } = await axiosClient.post<CuadraturaCaja>(
      `/cuadratura-cajas/${cajaId}/close`
    );
    return data;
  },

  /**
   * Obtener status de mi caja
   * GET /cuadratura-cajas/me/status
   */
  async obtenerMiStatus(): Promise<CajaStatusResponse> {
    const { data } = await axiosClient.get<CajaStatusResponse>(
      '/cuadratura-cajas/me/status'
    );
    return data;
  }
};
